import { LoginAccount } from 'domain/usecases/login-account'
import { SignupAccount } from 'domain/usecases/signup-account'
import { ClinicsService } from 'infra/services/clinics-service'
import { RolesService } from 'infra/services/roles-service'
import { route } from 'main/routes'
import { SignupFormValidation } from 'main/validations/usecases/signup-form-validation'
import { Background, CardBackground } from 'presentation/components'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { useRecoilState, useResetRecoilState } from 'recoil'
import { signupFormState } from './organism/signup-atom'
import SignupForm from './organism/signup-form'
import { UserInternalService } from 'infra/services/user-internal-service'

type SignupPageProps = {
  authSignup: SignupAccount
  authLogin: LoginAccount
  validations: SignupFormValidation
  clinicsService: ClinicsService
  rolesService: RolesService
  userService: UserInternalService
}

const SignupPage: React.FC<SignupPageProps> = (props) => {
  const [formGroup, setFormGroup] = useRecoilState(signupFormState)
  const navigate = useHistory()
  const resetState = useResetRecoilState(signupFormState)

  const loginAfterSignup = (params: { email: string; password: string }) => {
    props.authLogin
      .loginAccount(params)
      .then(() => navigate.push(route.dashboard.url))
      .catch(() => navigate.push(route.login.url))
  }

  useEffect(() => {
    return () => resetState()
  }, [])

  const onSubmit = () => {
    setFormGroup((current) => ({ ...current, isLoading: true }))
    props.userService.checkUserAvailability({ clinic_id: formGroup.clinic, name: formGroup.name }).then((res: any) => {
      if (res) {
        setFormGroup((current) => ({ ...current, remoteError: 'Oncologist name already exists, please change it', isLoading: false }))
      } else {
        props.authSignup
          .signupAccount({
            email: formGroup.email,
            name: formGroup.name,
            password: formGroup.password,
            role: formGroup.role,
            clinic: formGroup.clinic,
          })
          .then((res: any) => {
            props.userService.saveNewUser({
              id: res.userSub,
              email: formGroup.email,
              name: formGroup.name,
              password: formGroup.password,
              role: formGroup.role,
              clinic: formGroup.clinic,
            }).then(() => {
              setFormGroup((current) => ({ ...current, remoteError: '' }))
              loginAfterSignup({ email: formGroup.email, password: formGroup.password })
            }).catch((error) => {
              setFormGroup((current) => ({ ...current, remoteError: error.message }))
            })
          })
          .catch((error) => {
            setFormGroup((current) => ({ ...current, remoteError: error.message }))
          })
      }
    }).catch((error) => {
      setFormGroup((current) => ({ ...current, remoteError: error.message }))
    }).finally(() => setFormGroup((current) => ({ ...current, isLoading: false })))
  }

  return (
    <Background>
      <CardBackground className="signup-card">
        <SignupForm
          onSubmit={onSubmit}
          validations={props.validations}
          clinicsService={props.clinicsService}
          rolesService={props.rolesService}
        />
      </CardBackground>
    </Background>
  )
}

export default SignupPage
